import React, { useEffect } from 'react';
import { useAuthService } from './auth/hooks/useAuthService';

export default () => {
  const { authFetch, baseURL } = useAuthService();
  
  useEffect(() => {
    authFetch(baseURL + '/api/v1/identities')
      .then(result => console.log('Request', result));
  }, [authFetch, baseURL]);
  
  return <> </>;
};
